import { SubmitDownloadResponse } from "it/primatoo/openapi/api/org/schemas/common/docs/SubmitDownloadResponse";

export interface UiNotification {
  type: NotificationType;
  title: string;
  message: string;
}

export interface UiPropagatedNotification extends UiNotification {
  translated?: boolean;
}

export enum NotificationType {
  success = 'success',
  error = 'error',
  warning = 'warning',
  info = 'info'
}

export interface SessionNotification {
  id: number;
  name: string;
  description: string;
  createdAt: number;
  status: SessionNotificationStatus,
  actionType: SessionInfoType,
  payload?: any | SubmitDownloadResponse
}

export enum SessionInfoType {
  DOWNLOAD = 'DOWNLOAD',
  NOTIFICATION = 'NOTIFICATION'
}

export enum SessionNotificationStatus {
  ERROR = 'ERROR',
  WARNING = 'WARNING',
  RUNNING = 'RUNNING',
  STOPPED = 'STOPPED',
  COMPLETED = 'COMPLETED',
  PARTIAL_COMPLETED = 'PARTIAL_COMPLETED',

  INFO = 'INFO',
  SUCCESS = 'SUCCESS'
}
